<script>

import axios from 'axios';

const mainUrl = process.env.VUE_APP_API_URL;

export default class GeneralSeguradoEditRepository{


    async  updateAssociatedData(type,token,id,rawdata) {
        
       let prefix = '';

        const normalizedType = type?.toString().trim().toLowerCase();

         if (normalizedType === 'dependente') {
            prefix = 'dependentes';
        }else{
            prefix = 'segurados';
        }

        const baseURL = `${mainUrl}${prefix}/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const data = rawdata;
        const response = await axios.put(baseURL,data,{ headers });
        return response;
       
    }
   
    async  removeRegistry(token,id,prefix) {
        const baseURL =  `${mainUrl}${prefix}/remove/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.get(baseURL,{ headers });
        return response;
       
    }

     async  deleteRegistry(token,id,prefix,userType) {

        if (userType === 'dependente') {
            prefix = `dependente-${prefix}`;
        }
        const baseURL =  `${mainUrl}${prefix}/remove/${id}`;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.delete(baseURL,{ headers });
        return response;
       
    }

    async bulkUpdate(rawdata,token,prefix,userType){

        if (userType === 'dependente') {
            prefix = `dependente-${prefix}`;
        }

        const baseURL = `${mainUrl}${prefix}/bulk`
        const headers = {
            'Content-Type':'application/json',
            'Accept':'application/json',
            'Authorization':'Bearer '+token
        };
    
        try {
            const data = rawdata;
            const response = await axios.post(baseURL, data, { headers: headers });
            return response;
        } catch (error) {
            console.error("Erro ao enviar dados:", error.response ? error.response.data : error.message);
            throw error;
        }

    }

}
</script>
